// import 'babel-polyfill';
import Vue from 'vue'
import App from '@/App.vue';
import router from '@/router';
import VueClipboard from 'vue-clipboard2';
// import FooterMenu from '@/scripts/aha-header-footer-main';

// C S S
import './sass/style.scss';

Vue.component('App', App);

// S C R I P T  M O D U L E S
// FooterMenu();

Vue.config.productionTip = false

// P L U G I N S
Vue.use(VueClipboard)

// I N I T
window.vm = new Vue({
  render: h => h(App),
  router
}).$mount('#app')


// CHECK README.MD FOR DETAILS